import { render, staticRenderFns } from "./TasksFunnelChart.vue?vue&type=template&id=d18e60a4&scoped=true"
import script from "./TasksFunnelChart.vue?vue&type=script&lang=js"
export * from "./TasksFunnelChart.vue?vue&type=script&lang=js"
import style0 from "./TasksFunnelChart.vue?vue&type=style&index=0&id=d18e60a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18e60a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d18e60a4')) {
      api.createRecord('d18e60a4', component.options)
    } else {
      api.reload('d18e60a4', component.options)
    }
    module.hot.accept("./TasksFunnelChart.vue?vue&type=template&id=d18e60a4&scoped=true", function () {
      api.rerender('d18e60a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/TasksFunnelChart.vue"
export default component.exports